<template>
  <div id="IndexNotificadores_div">

    <menusuperior titulo="SINOJ" subtitulo="Sistema Integral de Notificación Judicial"></menusuperior>
    <menuizquierda></menuizquierda>

    <div v-if="$route.fullPath == RUTA_RAIZ_SISTEMA" class="d-flex justify-content-center align-items-center content-area">
      <div id="secciondebienvenidaSINOJ" class="d-flex flex-wrap align-items-center justify-content-center">
        <figure class="text-center">
          <img src="../../../assets/logo-pj-transparente-blanco.png" alt="Logo de Poder Judicial del Estado de Aguascalientes" />
        </figure>
        <h2>BIENVENIDOS AL SISTEMA SINOJ</h2>
        <h4></h4>
      </div>
    </div>

    <div v-show="$route.fullPath != RUTA_RAIZ_SISTEMA" class="content-area">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>

  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/Comunes/MenuIzquierdaDeLosSistemas.vue'
  import comun from '@/../static/js/comun'

  export default {
    name: 'Plantilla',
    components: {
      menusuperior: menusuperior,
      menuizquierda: menuizquierda
    },
    data() {
      return {
        RUTA_RAIZ_SISTEMA: '/SINOJ'
      }
    }
  }
</script>
<style scoped>
  #secciondebienvenidaSINOJ {
    width: 40vw;
    height: 600px;
    align-content: center;
  }

  #secciondebienvenidaSINOJ h2 {
    margin-top: 3vh;
    text-align: center;
  }

  #secciondebienvenidaSINOJ h4 {
    margin-top:1vh;
  }

  @media (max-width: 991px) {
    #secciondebienvenidaSINOJ h2 {
      font-size: .9rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/Plantilla.vue